"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("@/http/request"));
/** package */
var _default = exports.default = {
  // (PLAN_TASK_17)获取访店任务的e-Note
  getNote: function getNote(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: "/protected/app/planTask/getNote",
      method: 'post',
      data: data
    });
  }
};